import GameCard from "../game-card";
import style from "./style.css";
import { Link } from "preact-router/match";
import IconBorder from "../border-icon";
import { useMemo } from "preact/hooks";

const GamesWrapper = ({
  title,
  secondaryTitle,
  logo,
  games,
  isLoading,
  headerLink,
  reverse,
  gamesNum,
}) => {
  const header = useMemo(() => {
    if (!title) return undefined;
    if (headerLink) {
      return (
        <Link className={style.league_header} href={headerLink}>
          {!!logo && <IconBorder imgSrc={logo} />}
          <span className={style.league_name}>{title}</span>
          {!!secondaryTitle && <span className={style.secondary}>{secondaryTitle}</span>}
          <div className={style.competition_link}>View All {">"}</div>
        </Link>
      );
    }
    return (
      <div className={style.league_header}>
        {!!logo && <IconBorder imgSrc={logo} />}
        <span className={style.league_name}>{title}</span>
        {!!secondaryTitle && <span className={style.secondary}>{secondaryTitle}</span>}
      </div>
    );
  }, [headerLink, logo, title, secondaryTitle]);

  if (isLoading) {
    return (
      <div className={style.league_wrapper}>
        {header}
        <div class={"home_page_grid"}>
          {Array(gamesNum ?? 6)
            .fill()
            .map((g, i) => (
              <div key={i} className={style.game_link}>
                <GameCard isLoading={true} />
              </div>
            ))}
        </div>
      </div>
    );
  }

  if (!games || games.length === 0) return undefined;

  games.sort((a, b) => (reverse ? b.timestamp - a.timestamp : a.timestamp - b.timestamp));
  return (
    <div className={style.league_wrapper}>
      {header}
      <div class={"home_page_grid"}>
        {games.map((g) => (
          <Link key={g.id} className={style.game_link} href={`/game/${g.id}`}>
            <GameCard game={g} />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default GamesWrapper;
